<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BEoBWi/tc-custom/9781504015660.jpg?1706040201116" alt="This image is the cover for the book Law of the Land"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Law of the Land
      </h1>
      <p class="bookDescription body article font2">
        <b>National Book Award Finalist: “A learned, thoughtful, witty legal history for the layman” (<i>The New Yorker</i>).</b><br/><br/> What do the thoughts of a ravenous tiger have to do with the evolution of America’s legal system? How do the works of Jane Austen and Ludwig van Beethoven relate to corporal punishment? In <i>The Law of the Land</i>, Charles Rembar examines these and many other topics, illustrating the surprisingly entertaining history of US law.<br/>  <br/> Best known for his passionate efforts to protect literature, including <i>Lady Chatterley’s Lover</i>, from censorship laws, Rembar offers an exciting look at the democratic judicial system that will appeal to lawyers and laymen alike. From the dark days of medieval England, when legal disputes were settled by duel, through recent paradigm shifts in the interpretation and application of the legal code, <i>The Law of the Land</i> is a compelling and informative history of the rules and regulations we so often take for granted.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charles Rembar
      </h2>
      
      <p class="authorDescription body article">Charles Rembar (1915&ndash;2000) was an American lawyer. Born and raised in New Jersey, he earned his bachelor&rsquo;s degree from Harvard University in 1935 and his law degree from Columbia University in 1938. He spent several years working for New Deal agencies before serving in the US Army Air Corps during World War II. Rembar is best known as a constitutional- and First Amendment&ndash;rights lawyer. His work representing Henry Miller&rsquo;s&#160;<I>Tropic of Cancer</I>, D. H. Lawrence&rsquo;s&#160;<I>Lady Chatterley&rsquo;s Lover</I>, and John Cleland&rsquo;s&#160;<I>Fanny Hill&#160;</I>played a major role in changing the nation&rsquo;s approach to obscenity and censorship laws. His book&#160;<I>The End of Obscenity: The Trials of Lady Chatterley, Tropic of Cancer &amp; Fanny Hill by the Lawyer Who Defended Them</I>&#160;(1968) won the George Polk Award in journalism.&#160;<I>Perspective&#160;</I>(1975) is a collection of essays, and&#160;<I>The Law of the Land: The Evolution of Our Legal System</I>&#160;(1980) is a legal history of Western Europe and the United States.<BR /><BR /> Rembar also founded a law firm, Rembar &amp; Curtis, which represented well known writers such as Norman Mailer, Tom Clancy, Herman Wouk, and Louise Erdrich.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?26c1fda0